/**
 * Feature-flag client hook.
 *
 * The API's `feature_flags` middleware merges global + tenant-specific rows
 * from the `feature_flags` table (see `packages/db/src/repos/feature-flags.ts`).
 * The merged map is surfaced on `tenant.feature_flags` via `/v1/me`; missing
 * flags default to `false` so the UI fails closed on rollout.
 *
 * Consumers:
 *   const opbEnabled = useFeatureFlag('a10_off_page_brief');
 *   if (!opbEnabled) return null;
 */
import { useAuthStore } from './auth';

export function useFeatureFlag(flagName: string): boolean {
  return useAuthStore((s) => s.tenant?.feature_flags?.[flagName] ?? false);
}

/**
 * The whole merged flag map (missing → treat as false). Used by consumers
 * that filter registry-driven lists (sidebar, command palette) so a single
 * subscription covers every gated section.
 */
export function useFeatureFlags(): Record<string, boolean> {
  return useAuthStore((s) => s.tenant?.feature_flags ?? EMPTY_FLAGS);
}

const EMPTY_FLAGS: Record<string, boolean> = {};
